import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { logPageView } from '../utils/ga';

const RouteChangeTracker = () => {
  const location = useLocation();
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      if (!initialized) {
        setInitialized(true);
      }
      logPageView();
    }
  }, [initialized, location]);

  return null;
};

export default RouteChangeTracker;
